
export default {
    namespaced: true,
    state: {
        configData: {},
        currentPage: 1,
        perPage: 10,
        deletedList: []
    },
    getters: {
        DELETED_LIST: state => {
            return state.deletedList;
        },
        PARAMS: state => {
            return state.params;
        },
        CATEGORY_LIST: state => {
            return state.categoryList;
        },
        CONFIG_DATA: state => {
            return state.configData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
    },
    mutations: {
        DELETED_LIST: (state, payload) => {
            return state.deletedList = payload;
        },
        ADD_TO_DELETED_LIST: (state, payload) => {
            return state.deletedList.push(payload);
        },
        ADD_TO_CONFIG_DATA: (state, payload) => {
            return state.configData[payload.key] = payload.value;
        },
        DELETE_OF_CONFIG_DATA: (state, payload) => {
            return delete(state.configData[payload]);
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        CONFIG_DATA: (state, payload) => {
            return state.configData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        HANDLE_RESPONSE: (state, payload) => {
            let buf = {};
            for (let key in payload) {
                buf[payload[key]['id']] = payload[key]
            }

            return state.configData = buf;
        },

    },
    actions: {
        SAVE: async ({commit, state}, payload) => {
            let data = {
                list: state.configData,
                deleted: state.deletedList,
            };
            state.isSendingSAVE = true;
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/config',
                parameter: data,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.deletedList = [];
                    commit('HANDLE_RESPONSE', responseData.configData);
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay --;
                }
            });
        },
        GET_DATA: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/config',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('HANDLE_RESPONSE', responseData.configData);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }

    }
}